export const expandAccordionItem = (el: HTMLElement, onAnimationEnd?: () => void): void => {
    const innerHeight = el.scrollHeight;
    el.style.height = `${innerHeight}px`;

    requestAnimationFrame(() => {
        el.style.height = 'auto';
        if (onAnimationEnd) {
            onAnimationEnd();
        }
    });
};

export const collapseAccordionItem = (el: HTMLElement, onAnimationEnd?: () => void): void => {
    // get the current height of the element
    const accordionHeight = el.scrollHeight;
    // store the current transition value so we can restore it later
    const elementTransition = el.style.transition;
    // remove the transition so we can set the height to its current pixel height
    el.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(() => {
        el.style.height = `${accordionHeight}px`;
        el.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(() => {
            el.style.height = '0px';
            if (onAnimationEnd) {
                onAnimationEnd();
            }
        });
    });
};
